import { useTranslation } from '@eti/providers';
import { useEffect } from 'react';
export const useLinksAccessibility = _ref => {
  let {
    targetElement,
    productTitle,
    accordionOpen
  } = _ref;
  const {
    t
  } = useTranslation();
  const openInNewTabText = `, ${t('ScreenReader.Link.OpensInNewTab.AriaLabel.Text')}`;
  useEffect(() => {
    if (productTitle && targetElement.current) {
      const links = targetElement.current.querySelectorAll('a');
      links.forEach(link => {
        var _link$textContent;
        const linkText = (_link$textContent = link.textContent) === null || _link$textContent === void 0 ? void 0 : _link$textContent.trim();
        const opensInNewTab = link.hasAttribute('target') && link.getAttribute('target') === '_blank';
        const ariaLabel = `${productTitle} ${linkText}${opensInNewTab ? openInNewTabText : ''}`;
        link.setAttribute('aria-label', ariaLabel);
      });
    }
  }, [openInNewTabText, productTitle, targetElement, accordionOpen]);
};
//# sourceMappingURL=useLinkAccessibility.js.map